import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {z} from 'zod';
import {ToolExecuteParams, ToolResult} from 'common/src/modules/shared/copilot/copilot.types';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {ContentCardScratchpadState} from '../../scratchpad/contentCardScratchpad.types';
import validateAgentScratchpad from '../../utils/general/validateAgentScratchpad';
import {NodeType} from 'common/src/modules/nodes/nodes.types';
import {contentFeedsApi} from 'common/src/modules/contentFeeds/contentFeeds.api';
import describeIdFormat from 'common/src/modules/campaigns/copilot/skills/campaignSetupSkill/idHelpers/utils/describeIdFormat';
import {idHelper} from 'common/src/modules/campaigns/copilot/skills/campaignSetupSkill/idHelpers/idHelpers.config';
import {IdPrefix} from 'common/src/modules/campaigns/copilot/skills/campaignSetupSkill/idHelpers/idHelpers.enums';
import formatParseError from 'common/src/modules/campaigns/copilot/skills/campaignSetupSkill/idHelpers/utils/formatParseError';

const inputSchema = z.object({
  contentFeedId: z.string().describe(describeIdFormat(IdPrefix.ContentFeed)),
});

async function execute({
  input: {contentFeedId},
  toolUtils: {agentScratchpad},
}: ToolExecuteParams<typeof inputSchema, ContentCardScratchpadState>): Promise<ToolResult> {
  const validatedScratchpad = validateAgentScratchpad<ContentCardScratchpadState>(
    agentScratchpad,
    NodeType.CONTENT_FEED,
  );

  const parseResult = idHelper.parseContentFeedId(contentFeedId);

  if (parseResult.ok === false) {
    return toolError(formatParseError(parseResult.error));
  }

  const numericId = parseResult.numericId;
  const availableFeeds = await contentFeedsApi.getContentFeeds();

  if (!availableFeeds.some((f) => f.id === numericId)) {
    return toolError(
      `Content feed ${idHelper.toContentFeedId(numericId)} is not available. Available content feeds: ${availableFeeds.map((f) => `${idHelper.toContentFeedId(f.id)}: ${f.name}`).join(', ')}`,
    );
  }

  validatedScratchpad.card.contentFeedId = numericId;

  return toolResult(`Content feed set to ${idHelper.toContentFeedId(numericId)}`);
}

export default function setContentFeedTool() {
  return tool({
    name: V2CardAgentToolName.SetContentFeed,
    displayName: 'Setting content feed',
    description: 'Set the content feed for the card.',
    inputSchema,
    execute,
  });
}
